export class JmkwEvent {
  constructor(
    public sourceId: string,
    public event: unknown,
    public source?: unknown
  ) {}
}
